import React from 'react';
import { Link } from 'react-router-dom';
import {
    Layout, Breadcrumb, Card, Button, Row, Col, Descriptions,
    message, Tag, Spin, Timeline, Alert, Modal, Input
} from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import moment from 'moment';
import { shopInstance } from '../../../config/api';
import CONSTANT from '../../../config/constant';
import * as COMMON from '../../../config/common';

export default class DetailOrder extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            order: null,
            transferId: null,
            transaction: null,
            userId: JSON.parse(localStorage.getItem(CONSTANT.STORAGE_KEY_USER))._id,
            loadingOrder: true,
            trackingLogs: [],
            trackingLoading: false,
            trackingError: null,
            shippingActionModal: {
                visible: false,
                action: null, // 'approve_return' or 're_deliver'
                note: '',
                loading: false
            }
        };
    }


    async componentDidMount() {
        this.fetch();
    }

    componentDidUpdate(prevProps, prevState) {
        // Fetch tracking logs when order is loaded and status allows tracking
        if (prevState.order !== this.state.order && this.state.order && !this.state.trackingLoading) {
            if (this.state.order.status !== 'paid' && this.state.trackingLogs.length === 0) {
                this.fetchTrackingLogs();
            }
        }
    }

    fetch = async () => {
        this.setState({ loadingOrder: true });
        if (this.props.match.params.id) {
            await shopInstance.get(`${CONSTANT.API.PRODUCT.ORDER}/${this.props.match.params.id}?agency=${this.state.userId}`)
                .then(res => {
                    if (res && res.data && res.code === 200) {
                        this.setState({
                            loadingOrder: false,
                            order: res.data,
                        })
                    }
                }).catch(error => {
                    this.setState({ loadingOrder: false });
                    message.error('Lỗi lấy thông tin đơn hàng: ' + error.message);
                })
        }
        else {
            this.setState({ loadingOrder: false });
            message.warning('Đơn hàng không tồn tại mã đơn hàng !').then(res => this.props.history.goBack());
        }
    }

    // nhận xác nhận đơn hàng
    confirmOrder = async (isConfirmed = true) => {
        this.setState({ loading: true });
        await shopInstance.patch(`${CONSTANT.API.AGENCY.AGENCY}/${this.props.match.params.id}/confirmation`
            , {
                isConfirmed: isConfirmed
            }
        )
            .then(res => {
                console.log(res);
                this.setState({ loading: false });
                if (res && res.data && res.code === 200) {
                    message.success(isConfirmed ? 'Xác nhận đơn hàng thành công!' : 'Từ chối đơn hàng thành công!');
                    this.fetch(); // Refresh data
                } else {
                    message.error('Có lỗi xảy ra!');
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                message.error('Có lỗi xảy ra: ' + error.message);
            });
    }

    // Cập nhật trạng thái đơn hàng theo quy trình
    updateOrderStatus = async (newStatus) => {
        this.setState({ loading: true });
        if (this.props.match.params.id) {
            await shopInstance.patch(`${CONSTANT.API.PRODUCT.ORDER}/${this.props.match.params.id}`, {
                status: newStatus,
                actUpd: 'udpStatus'
            })
                .then(res => {
                    this.setState({ loading: false });
                    if (res && res.data && res.code === 200) {
                        message.success('Cập nhật trạng thái thành công!');
                        this.fetch(); // Refresh data
                    }
                    else {
                        message.error('Cập nhật trạng thái không thành công!');
                    }
                })
                .catch(error => {
                    message.error('Cập nhật trạng thái không thành công!' + error.message);
                    this.setState({ loading: false });
                });
        }
        else {
            this.setState({ loading: false });
            message.error('Cập nhật trạng thái không thành công!');
        }
    }

    // Mapping tracking status codes to Vietnamese labels
    getTrackingStatusInfo = (statusCode, statusName) => {
        const statusMap = {
            "created": { "title": "Tạo đơn hàng", "description": "" },
            "101": { "title": "ViettelPost từ chối nhận", "description": "ViettelPost từ chối nhận đơn hàng" },
            "102": { "title": "Đơn hàng chờ xử lý", "description": "Đơn hàng chờ xử lý" },
            "103": { "title": "Giao cho bưu cục", "description": "Bưu cục tiếp nhận đơn hàng" },
            "104": { "title": "Giao cho bưu tá đi nhận", "description": "Đã phân công bưu tá đi nhận" },
            "105": { "title": "Bưu tá đã nhận hàng", "description": "Bưu tá đã nhận hàng thành công" },
            "107": { "title": "Đối tác yêu cầu hủy", "description": "Đối tác yêu cầu hủy qua API" },
            "200": { "title": "Nhận từ bưu tá - Bưu cục gốc", "description": "VTP đã nhận hàng và nhập doanh thành công" },
            "201": { "title": "Hủy nhập phiếu gửi", "description": "Hủy nhập phiếu gửi" },
            "202": { "title": "Sửa phiếu gửi", "description": "Sửa phiếu gửi" },
            "300": { "title": "Khai thác đi", "description": "Đóng tải" },
            "400": { "title": "Khai thác đến", "description": "Bàn giao hoặc nhận bàn giao" },
            "500": { "title": "Giao bưu tá đi phát", "description": "Phân công bưu tá đi giao hàng" },
            "501": { "title": "Phát thành công", "description": "Thành công - Phát thành công" },
            "502": { "title": "Chuyển hoàn bưu cục gốc", "description": "Chuyển hoàn bưu cục gốc" },
            "503": { "title": "Hủy - Yêu cầu khách", "description": "Hủy theo yêu cầu khách hàng" },
            "504": { "title": "Hoàn thành công - Chuyển trả", "description": "Thành công - Chuyển hoàn lại cho người gửi" },
            "505": { "title": "Phát thất bại - Chuyển hoàn", "description": "Thông báo chuyển hoàn bưu cục gốc/ Sai thông tin/ KH từ chối nhận" },
            "506": { "title": "Phát thất bại", "description": "Khách hàng nghỉ, không có nhà/ Không nghe máy/ Hẹn giao lại" },
            "507": { "title": "Khách nhận tại bưu cục", "description": "Khách hàng đến bưu cục nhận" },
            "508": { "title": "Phát tiếp", "description": "Đơn vị yêu cầu phát tiếp" },
            "509": { "title": "Chuyển tiếp bưu cục khác", "description": "Chuyển tiếp bưu cục khác" },
            "515": { "title": "Duyệt hoàn", "description": "Bưu cục phát duyệt hoàn" },
            "550": { "title": "Phát tiếp", "description": "Khách hàng yêu cầu phát tiếp" }
        };

        const normalizedStatus = statusCode?.toString() || statusName?.toLowerCase();
        return statusMap[normalizedStatus] || statusMap[statusCode] || {
            title: statusName || `Trạng thái ${statusCode || 'Không xác định'}`,
            description: ''
        };
    }

    // Parse raw tracking data
    parseRawTrackingData = (rawData) => {
        if (!rawData) return null;
        if (typeof rawData === 'string') {
            try {
                return JSON.parse(rawData);
            } catch (err) {
                console.warn('Unable to parse tracking rawData', err);
                return null;
            }
        }
        return typeof rawData === 'object' ? rawData : null;
    }

    // Fetch tracking logs
    fetchTrackingLogs = async (force = false) => {
        if (!this.state.order?._id) return;

        // If not forced, check status condition
        if (!force) {
            const trackingStatuses = ['confirmed', 'fulfill', 'delivery', 'completed'];
            if (!trackingStatuses.includes(this.state.order.status)) {
                return;
            }
        }

        try {
            this.setState({ trackingLoading: true, trackingError: null });
            const response = await shopInstance.get(`${CONSTANT.API.USER.ORDER_TRACKING_LOGS}/${this.state.order._id}`);

            const data = response?.data || response?.logs || response;
            console.log(data)
            const logs = Array.isArray(data) ? data : (data?.docs || []);

            const normalizedLogs = logs
                .map((log) => {
                    const parsedRaw = this.parseRawTrackingData(log.rawData);
                    return {
                        ...log,
                        rawData: parsedRaw,
                        receivedAt: log.receivedAt || log.created_at || log.updated_at || null
                    };
                })
                .sort((a, b) => {
                    const aTime = a.receivedAt ? moment(a.receivedAt).valueOf() : 0;
                    const bTime = b.receivedAt ? moment(b.receivedAt).valueOf() : 0;
                    return aTime - bTime;
                });

            this.setState({ trackingLogs: normalizedLogs });
        } catch (err) {
            console.error('Failed to load tracking logs:', err);
            this.setState({ trackingError: err });
        } finally {
            this.setState({ trackingLoading: false });
        }
    }

    // Check if latest tracking log has status 505
    hasStatus505 = () => {
        if (!this.state.trackingLogs || this.state.trackingLogs.length === 0) return false;
        const latestLog = this.state.trackingLogs[this.state.trackingLogs.length - 1];
        return latestLog.statusCode === 505 || latestLog.statusCode === '505';
    }

    // Open modal for shipping action
    openShippingActionModal = (action) => {
        this.setState({
            shippingActionModal: {
                visible: true,
                action: action,
                note: '',
                loading: false
            }
        });
    }

    // Close modal
    closeShippingActionModal = () => {
        this.setState({
            shippingActionModal: {
                visible: false,
                action: null,
                note: '',
                loading: false
            }
        });
    }

    // Handle note change
    handleNoteChange = (e) => {
        this.setState({
            shippingActionModal: {
                ...this.state.shippingActionModal,
                note: e.target.value
            }
        });
    }

    // Submit shipping action
    handleSubmitShippingAction = async () => {
        const { action, note } = this.state.shippingActionModal;
        if (!action || !this.state.order?._id) return;

        try {
            this.setState({
                shippingActionModal: {
                    ...this.state.shippingActionModal,
                    loading: true
                }
            });

            const response = await shopInstance.post(CONSTANT.API.AGENCY.UPDATE_SHIPPING_ORDER, {
                status: action,
                orderId: this.state.order._id,
                note: note || ''
            });

            if (response && response.code === 200) {
                message.success(action === 'approve_return' ? 'Duyệt hoàn thành công!' : 'Yêu cầu phát tiếp thành công!');
                this.closeShippingActionModal();
                // Refresh order data first, then tracking logs
                await this.fetch();
                // Force refresh tracking logs after order update
                await this.fetchTrackingLogs(true);
            } else {
                message.error(response?.message || 'Có lỗi xảy ra!');
            }
        } catch (err) {
            console.error('Failed to update shipping order:', err);
            message.error('Có lỗi xảy ra: ' + (err.response?.data?.message || err.message));
        } finally {
            this.setState({
                shippingActionModal: {
                    ...this.state.shippingActionModal,
                    loading: false
                }
            });
        }
    }

    render() {
        const { loading, order, loadingOrder } = this.state;
        return (
            <div>
                <Breadcrumb style={{ margin: '16px 0' }}>
                    <Breadcrumb.Item >
                        <Link to="/"><HomeOutlined /></Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item >
                        <Link to="/order">Danh sách đơn hàng</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Thông tin đơn hàng
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Layout.Content className="layout-content">
                    {
                        loadingOrder &&
                        <div style={{ textAlign: 'center' }}>
                            <Spin />
                        </div>
                    }
                    {
                        !loadingOrder && order ? <>
                            <Row gutter={16}>
                                <Col xs={24} sm={24} md={18}>
                                    {/* Hiển thị tag trạng thái cho tất cả các status */}
                                    {order.status === 'paid' && <Descriptions.Item label="Trạng thái" labelStyle={{ color: '#777' }}><Tag color="orange" style={{ marginBottom: '8px' }}>Chờ xác nhận</Tag></Descriptions.Item>}
                                    {order.status === 'confirmed' && <Descriptions.Item label="Trạng thái" labelStyle={{ color: '#777' }}><Tag color="green" style={{ marginBottom: '8px' }}>Đơn hàng đã xác nhận</Tag></Descriptions.Item>}
                                    {order.status === 'fulfill' && <Descriptions.Item label="Trạng thái" labelStyle={{ color: '#777' }}><Tag color="blue" style={{ marginBottom: '8px' }}>Đang chuẩn bị hàng</Tag></Descriptions.Item>}
                                    {order.status === 'delivery' && <Descriptions.Item label="Trạng thái" labelStyle={{ color: '#777' }}><Tag color="purple" style={{ marginBottom: '8px' }}>Đang giao hàng</Tag></Descriptions.Item>}
                                    {order.status === 'completed' && <Descriptions.Item label="Trạng thái" labelStyle={{ color: '#777' }}><Tag color="green" style={{ marginBottom: '8px' }}>Đơn hàng đã giao hoàn tất</Tag></Descriptions.Item>}
                                    {order.status === 'cancelled' && <Descriptions.Item label="Trạng thái" labelStyle={{ color: '#777' }}><Tag color="red" style={{ marginBottom: '8px' }}>Đơn hàng đã hủy</Tag></Descriptions.Item>}
                                    <Descriptions title={"Order: #TATINTA-S" + order.uid}></Descriptions>

                                    <Descriptions title="Thông tin giao hàng" column={{ md: 2 }}>
                                        <Descriptions.Item label="Họ tên" labelStyle={{ color: '#777' }}>{order.shipping.full_name}</Descriptions.Item>
                                        <Descriptions.Item label="Email" labelStyle={{ color: '#777' }}>{order.shipping.email}</Descriptions.Item>
                                        <Descriptions.Item label="Điện thoại" labelStyle={{ color: '#777' }}>{order.shipping.phone}</Descriptions.Item>
                                        <Descriptions.Item label="Địa chỉ" labelStyle={{ color: '#777' }}>
                                            {/* {order.shipping.information_shippinginformation_shipping + ',' + order.shipping.address_2 + ',' + order.shipping.city + ',' + order.shipping.country}</Descriptions.Item> */}
                                            {order?.shipping?.address}
                                            {order?.shipping?.information_shipping?.wardName ? ', ' + order?.shipping?.information_shipping?.wardName : ''}
                                            {order?.shipping?.information_shipping?.districtName ? ', ' + order?.shipping?.information_shipping?.districtName : ''}
                                            {order?.shipping?.information_shipping?.provinceName ? ', ' + order?.shipping?.information_shipping?.provinceName : ''}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    {/* <Descriptions title="Giao dịch thanh toán" column={{ md: 2 }}>
                                        <Descriptions.Item label="Phương thức thanh toán" labelStyle={{ color: '#777' }}>{order.payment_method_title || '-'}</Descriptions.Item>
                                        <Descriptions.Item label="Tình trạng giao dịch" labelStyle={{ color: '#777' }}>{CONSTANT.STATUS[`${this.state.statusOrder}`]}</Descriptions.Item>
                                        <Descriptions.Item label="Ngày tạo giao dịch" labelStyle={{ color: '#777' }}>{order.created_at ? moment(order.created_at).format(CONSTANT.DATE_FORMAT) : "-"}</Descriptions.Item>
                                        <Descriptions.Item label="Ngày hoàn thành giao dịch" labelStyle={{ color: '#777' }}>{order.date_paymented ? moment(order.date_paymented).format(CONSTANT.DATE_FORMAT) : "-"}</Descriptions.Item>
                                        <Descriptions.Item label="Mã giao dịch " labelStyle={{ color: '#777' }}>{order.payment_id}</Descriptions.Item>
                                    </Descriptions> */}

                                    {/* Thông tin trạng thái giao hàng */}
                                    {(order.status !== 'paid') && (
                                        <>
                                    <Descriptions title="Thông tin trạng thái giao hàng" column={{ md: 2 }}>
                                                {this.state.trackingError && (
                                                    <Alert
                                                        message="Lỗi tải thông tin vận chuyển"
                                                        description="Không thể tải thông tin vận chuyển. Vui lòng thử lại sau."
                                                        type="error"
                                                        showIcon
                                                        style={{ marginBottom: 16 }}
                                                    />
                                                )}
                                                {!this.state.trackingLoading && !this.state.trackingError && this.state.trackingLogs.length === 0 && (
                                                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                                        Chưa có thông tin vận chuyển
                                                    </div>
                                                )}
                                    </Descriptions>
                                            {!this.state.trackingLoading && this.state.trackingLogs.length > 0 && (
                                                <>
                                                    <Timeline>
                                                        {this.state.trackingLogs.map((log, index) => {
                                                            const statusInfo = this.getTrackingStatusInfo(log.statusCode, log.statusName);
                                                            const formattedTime = log.receivedAt
                                                                ? moment(log.receivedAt).format('DD/MM/YYYY | HH:mm')
                                                                : '';
                                                            const isLast = index === this.state.trackingLogs.length - 1;
                                                            const parsedRaw = log.rawData;
                                                            const carrierLabel = log.carrier === 'viettel_post' ? 'Viettel Post' : (log.carrier || '');

                                                            return (
                                                                <Timeline.Item
                                                                    key={`${log._id || log.statusCode}-${index}`}
                                                                    color={isLast ? '#1890ff' : '#d9d9d9'}
                                                                >
                                                                    <div style={{ marginBottom: 8 }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                                                                            <strong style={{ fontSize: 14 }}>{statusInfo.title}</strong>
                                                                            {log.statusCode && (
                                                                                <Tag color="default" style={{ fontSize: 11 }}>
                                                                                    Mã: {log.statusCode}
                                                                                </Tag>
                                                                            )}
                                                                        </div>
                                                                        {statusInfo.description && (
                                                                            <div style={{ color: '#666', fontSize: 13, marginBottom: 4 }}>
                                                                                {statusInfo.description}
                                                                            </div>
                                                                        )}
                                                                        {parsedRaw?.note && (
                                                                            <div style={{ color: '#666', fontSize: 13, marginBottom: 4, fontStyle: 'italic' }}>
                                                                                {parsedRaw.note}
                                                                            </div>
                                                                        )}
                                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, fontSize: 12, color: '#999' }}>
                                                                            {formattedTime && <span>{formattedTime}</span>}
                                                                            {carrierLabel && <span>Đơn vị vận chuyển: {carrierLabel}</span>}
                                                                            {log.trackingCode && <span>Mã vận đơn: {log.trackingCode}</span>}
                                                                        </div>
                                                                    </div>
                                                                </Timeline.Item>
                                                            );
                                                        })}
                                                    </Timeline>
                                                    {/* Action buttons for status 505 */}
                                                    {this.hasStatus505() && (
                                                        <Card 
                                                            style={{ marginTop: 16, backgroundColor: '#fff7e6', borderColor: '#ffd591' }}
                                                            title={<span style={{ color: '#d46b08' }}>Yêu cầu xác nhận</span>}
                                                        >
                                                            <Alert
                                                                message="Đơn hàng giao thất bại - Chuyển hoàn"
                                                                description="Vui lòng chọn một trong các hành động sau:"
                                                                type="warning"
                                                                showIcon
                                                                style={{ marginBottom: 16 }}
                                                            />
                                                            <Row gutter={12}>
                                                                <Col span={12}>
                                                                    <Button
                                                                        type="primary"
                                                                        danger
                                                                        block
                                                                        onClick={() => this.openShippingActionModal('approve_return')}
                                                                        style={{ height: '40px' }}
                                                                    >
                                                                        Duyệt hoàn
                                                                    </Button>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <Button
                                                                        type="primary"
                                                                        block
                                                                        onClick={() => this.openShippingActionModal('re_deliver')}
                                                                        style={{ height: '40px' }}
                                                                    >
                                                                        Phát tiếp
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}

                                    <div className="ant-table-content">
                                        <table style={{ tableLayout: "auto", width: "100%" }}>
                                            <thead className="ant-table-thead">
                                                <tr>
                                                    <th className="ant-table-cell">Hình ảnh</th>
                                                    <th className="ant-table-cell">Tên sản phẩm</th>
                                                    <th className="ant-table-cell">Số lượng</th>
                                                    <th className="ant-table-cell">Đơn giá</th>
                                                    <th className="ant-table-cell">Thành tiền</th>
                                                </tr>
                                            </thead>
                                            <tbody className="ant-table-tbody">
                                                {
                                                    order.shop?.[0]?.items && order.shop[0].items.length > 0 && order.shop[0].items.map((item, index) => (
                                                        <tr className="ant-table-row" key={index}>
                                                            <td className="ant-table-cell" style={{ width: '150px' }}>
                                                                <img src={COMMON.getImageVariant(item)} style={{ width: '100%' }}
                                                                    alt={item.product.name}
                                                                />
                                                            </td>
                                                            <td className="ant-table-cell" style={{ width: '400px' }}>
                                                                <h4 className="product-title">{item.product.name}</h4>
                                                                <p className="product-attribute">
                                                                    {
                                                                        item.variant && item.variant.attributes.map((attr, indexAttr) => {
                                                                            let str = attr.options[0].name;
                                                                            if (indexAttr < item.variant.attributes.length - 1)
                                                                                str += " / ";
                                                                            return str + ' ';
                                                                        })
                                                                    }
                                                                </p>
                                                            </td>
                                                            <td className="ant-table-cell" style={{ textAlign: 'right' }}>
                                                                {item.quantity}
                                                            </td>
                                                            <td className="ant-table-cell" style={{ textAlign: 'right' }}>
                                                                {COMMON.currencyFormat(parseFloat(item.price))} {COMMON.getCurrency(item.product.currency)}
                                                            </td>
                                                            <td className="ant-table-cell" style={{ textAlign: 'right' }}>
                                                                {COMMON.currencyFormat(parseFloat(item.price * item.quantity))} {COMMON.getCurrency(item.product.currency)}
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                        <div className="ant-table-footer">
                                            <div style={{ float: 'left', width: '100%', padding: '10px 0', borderBottom: '1px #ccc solid' }}>
                                                <span style={{ float: 'left' }}>Phí ship</span>
                                                <span style={{ float: 'right', fontWeight: 700 }}>
                                                    {(order.shop?.[0]?.shop_total &&
                                                        `${COMMON.currencyFormat(order?.shipping_total)} ${COMMON.getCurrency(order.currency)}`) || 0}
                                                </span>
                                            </div>
                                            <div style={{ float: 'left', width: '100%', padding: '10px 0', borderBottom: '1px #ccc solid' }}>
                                                <span style={{ float: 'left', fontWeight: 700 }}>Tổng tiền hàng</span>
                                                <span style={{ float: 'right', fontWeight: 700 }}>
                                                    {(order.shop?.[0]?.shop_total &&
                                                        `${COMMON.currencyFormat(order.shop[0].shop_total + order?.shipping_total)} ${COMMON.getCurrency(order.currency)}`) || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={6}>
                                    {console.log(order.status)}

                                    {/* Status = paid: Hiển thị 2 nút xác nhận */}
                                    {
                                        order?.status === 'paid' && (
                                            <Card title="Xác nhận đơn hàng" bordered={false}>
                                                <Row gutter={8}>
                                                    <Col span={12}>
                                                        <Button
                                                            type="primary"
                                                            loading={loading}
                                                            onClick={() => this.confirmOrder(true)}
                                                            style={{ width: '100%' }}
                                                        >
                                                            Xác nhận có hàng
                                                        </Button>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Button
                                                            danger
                                                            loading={loading}
                                                            onClick={() => this.confirmOrder(false)}
                                                            style={{ width: '100%' }}
                                                        >
                                                            Không xác nhận
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        )
                                    }

                                    {/* Status = confirmed: Hiển thị nút fulfill */}
                                    {/* {
                                        order?.status === 'confirmed' && (
                                            <Card title="Cập nhật trạng thái" bordered={false}>
                                                <Button
                                                    type="primary"
                                                    loading={loading}
                                                    onClick={() => this.updateOrderStatus('fulfill')}
                                                    style={{ width: '100%' }}
                                                >
                                                    Bắt đầu chuẩn bị hàng
                                                </Button>
                                            </Card>
                                        )
                                    } */}

                                    {/* Status = confirmed: Hiển thị nút delivery */}
                                    {
                                        order?.status === 'confirmed' && (
                                            <Card title="Cập nhật trạng thái" bordered={false}>
                                                <Button
                                                    type="primary"
                                                    loading={loading}
                                                    onClick={() => this.updateOrderStatus('delivery')}
                                                    style={{ width: '100%' }}
                                                >
                                                    Bắt đầu giao hàng
                                                </Button>
                                            </Card>
                                        )
                                    }

                                    {/* Status = delivery: Hiển thị nút completed */}
                                    {
                                        order?.status === 'delivery' && (
                                            <Card title="Cập nhật trạng thái" bordered={false}>
                                                <Button
                                                    type="primary"
                                                    loading={loading}
                                                    onClick={() => this.updateOrderStatus('completed')}
                                                    style={{ width: '100%' }}
                                                >
                                                    Hoàn thành đơn hàng
                                                </Button>
                                            </Card>
                                        )
                                    }

                                    {/* Status = completed: Không hiển thị nút nào */}
                                    {
                                        order?.status === 'completed' && (
                                            <Card title="Trạng thái đơn hàng" bordered={false}>
                                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                                    <Tag color="green" style={{ fontSize: '16px', padding: '8px 16px' }}>
                                                        Đơn hàng đã hoàn thành
                                                    </Tag>
                                                </div>
                                            </Card>
                                        )
                                    }

                                    {/* Status = cancelled: Không hiển thị nút nào */}
                                    {
                                        order?.status === 'cancelled' && (
                                            <Card title="Trạng thái đơn hàng" bordered={false}>
                                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                                    <Tag color="red" style={{ fontSize: '16px', padding: '8px 16px' }}>
                                                        Đơn hàng đã hủy
                                                    </Tag>
                                                </div>
                                            </Card>
                                        )
                                    }

                                </Col>
                            </Row></> : null
                    }

                </Layout.Content>
                {/* Modal for shipping action with note */}
                <Modal
                    title={this.state.shippingActionModal.action === 'approve_return' ? 'Duyệt hoàn đơn hàng' : 'Yêu cầu phát tiếp'}
                    visible={this.state.shippingActionModal.visible}
                    onOk={this.handleSubmitShippingAction}
                    onCancel={this.closeShippingActionModal}
                    confirmLoading={this.state.shippingActionModal.loading}
                    okText={this.state.shippingActionModal.action === 'approve_return' ? 'Xác nhận duyệt hoàn' : 'Xác nhận phát tiếp'}
                    cancelText="Hủy"
                    width={600}
                >
                    <div style={{ marginBottom: 16 }}>
                        <p style={{ marginBottom: 8, fontWeight: 500 }}>
                            {this.state.shippingActionModal.action === 'approve_return' 
                                ? 'Bạn có chắc chắn muốn duyệt hoàn đơn hàng này không?'
                                : 'Bạn có chắc chắn muốn yêu cầu phát tiếp đơn hàng này không?'}
                        </p>
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
                            Ghi chú (tùy chọn):
                        </label>
                        <Input.TextArea
                            rows={4}
                            placeholder="Nhập ghi chú..."
                            value={this.state.shippingActionModal.note}
                            onChange={this.handleNoteChange}
                            maxLength={500}
                            showCount
                        />
                    </div>
                </Modal>
            </div>
        )
    }
}
